// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70320a0e","676":"9f5694a1"}[chunkId] + ".chunk.js";
};